/* ══════════════════════════════════════════════════════════════════════════
 * CLS-FI FAQ data (Finnish)
 * Replace with backend-driven content when /api/faq/{brandSlug} ships.
 * ══════════════════════════════════════════════════════════════════════════ */

export const CATEGORIES = [
  { id: 'ordering',  label: 'Tilaaminen' },
  { id: 'design',    label: 'Suunnittelu & painatus' },
  { id: 'delivery',  label: 'Toimitus' },
  { id: 'sizing',    label: 'Koot & istuvuus' },
  { id: 'payment',   label: 'Maksaminen' },
  { id: 'aftercare', label: 'Pesu & hoito' },
];

export const QUESTIONS = [
  {
    id: 'order-before-drawing',
    category: 'ordering',
    popular: true,
    popularRank: 1,
    question: 'Voinko tilata ennen kuin olemme toimittaneet piirroksen?',
    answer:
      'Kyllä. Voit aloittaa tilauksen ja tehdä tilauksesi luokkakaupassa, vaikka piirros ei olisi vielä valmis. Aloitamme tuotannon heti, kun saamme lopullisen piirroksen luokkaedustajalta.',
  },
  {
    id: 'order-deadline',
    category: 'ordering',
    popular: true,
    popularRank: 2,
    question: 'Milloin on viimeinen tilauspäivä?',
    answer:
      'Määräaika näkyy luokkakaupassasi. Nyrkkisääntönä meidän on saatava tilauksesi viimeistään 3 viikkoa ennen opintomatkaa, jotta ehdimme painaa, tarkastaa laadun ja toimittaa.',
  },
  {
    id: 'modify-order',
    category: 'ordering',
    popular: true,
    popularRank: 3,
    question: 'Voinko muuttaa tai peruuttaa tilaukseni?',
    answer:
      'Kyllä, voit muuttaa tilaustasi 24 tunnin ajan tilauksen jälkeen tilausvahvistuksessa olevasta "Muokkaa tilausta" -linkistä. Sen jälkeen tuotanto alkaa, eivätkä muutokset ole enää mahdollisia.',
  },
  {
    id: 'no-confirmation',
    category: 'ordering',
    popular: true,
    popularRank: 4,
    question: 'En ole saanut tilausvahvistustani — mitä teen?',
    answer:
      'Tarkista ensin roskapostisuodattimesi. Jos vahvistusta ei löydy sieltä, lähetä meille sähköpostia osoitteeseen info@clseifert.fi nimelläsi ja koulullasi, niin lähetämme sen manuaalisesti.',
  },
  {
    id: 'drawing-adjustments',
    category: 'design',
    popular: true,
    popularRank: 5,
    question: 'Säädättekö piirrosta, jos se ei ole painokelpoinen?',
    answer:
      'Kyllä. Graafikkomme käyvät läpi kaikki piirrokset ja tekevät pieniä säätöjä veloituksetta, jotta ne ovat painokelpoisia. Suurempien muutosten yhteydessä otamme yhteyttä luokkaedustajaan.',
  },
  {
    id: 'sizing-help',
    category: 'sizing',
    popular: true,
    popularRank: 6,
    question: 'Miten löydän oikean koon?',
    answer:
      'Suosittelemme mittaamaan hupparin tai t-paidan, joka istuu hyvin, ja vertaamaan sitä kokotaulukkoomme. Löydät sen jokaisen tuotteen kohdalta.',
  },
  {
    id: 'shrinkage',
    category: 'aftercare',
    popular: true,
    popularRank: 7,
    question: 'Kutistuvatko paidat pesun jälkeen?',
    answer:
      'Hupparimme ovat esikutistettuja ja kutistuvat minimaalisesti, jos peset ne 30 °C:ssa ja kuivaat ne narulla. Pese aina nurinpäin painatuksen suojaamiseksi.',
  },
  {
    id: 'back-print-uniform',
    category: 'design',
    popular: true,
    popularRank: 8,
    question: 'Tuleeko selkäpainatus täysin samanlaiseksi kaikkiin paitoihin?',
    answer:
      'Kyllä, kaikki selkäpainatukset tehdään samalla mallilla, joten niistä tulee visuaalisesti samanlaisia. Pieniä 2–3 mm:n eroja voi esiintyä, koska painatus tehdään käsin.',
  },
  {
    id: 'delivery-time',
    category: 'delivery',
    popular: true,
    popularRank: 9,
    question: 'Milloin saan paitani?',
    answer:
      'Vakiotuotanto kestää 2–3 viikkoa määräajasta. Lähetämme seurantanumeron heti, kun paketti lähtee verstaaltamme.',
  },
  {
    id: 'color-variation',
    category: 'design',
    question: 'Tuleeko painoväristä täsmälleen samanlainen kuin näytöllä?',
    answer:
      'Sovitamme värit mahdollisimman tarkasti Pantone-asteikkoon, mutta pieniä eroja näytön ja fyysisen painatuksen välillä voi esiintyä kankaasta ja valaistuksesta riippuen.',
  },
  {
    id: 'payment-methods',
    category: 'payment',
    question: 'Mitä maksutapoja voin käyttää?',
    answer:
      'Hyväksymme Visan, Mastercardin, MobilePayn ja laskun. Luokille tarjoamme myös koottua laskutusta koulun markkinointibudjetin kautta.',
  },
  {
    id: 'school-budget',
    category: 'payment',
    question: 'Voimmeko maksaa koulun markkinointibudjetista?',
    answer:
      'Kyllä. Valitse kassalla "Markkinointibudjetti", niin lähetämme kootun laskun koulun hallinnolle. Summaa ei veloiteta oppilailta yksittäin.',
  },
  {
    id: 'delivery-address',
    category: 'delivery',
    question: 'Pitääkö kaikki paidat toimittaa koululle?',
    answer:
      'Voit valita joko toimituksen koululle (ilmainen, koottu) tai kotiinkuljetuksen jokaiselle oppilaalle. Kotiinkuljetus maksaa 49 € per lähetys.',
  },
  {
    id: 'wrong-size',
    category: 'sizing',
    question: 'Mitä teen, jos olen tilannut väärän koon?',
    answer:
      'Voit vaihtaa toiseen kokoon 14 päivän kuluessa vastaanottamisesta, kunhan paitaa ei ole käytetty tai pesty. Ota yhteyttä osoitteeseen info@clseifert.fi.',
  },
];
